import * as yup from 'yup';
import { FileUtil, FormValidationUtil, DateUtil } from '../../../utils';

export const initialValues = {
  compOffCategory: 'In Office',
  compOffDate: '',
  fromTime: '',
  toTime: '',
  reason: '',
  file: [],
  attachmentPath: '',
  hrs: '',
  leaveDays: '',
};

export const validationSchema = yup.object().shape({
  compOffCategory: yup.string().required('Comp Off Category is required'),
  compOffDate: yup
    .date()
    .transform((curr, orig) => (orig === '' ? null : new Date(orig)))
    .typeError('Invalid date')
    .required('Comp Off Date is required'),
  fromTime: yup.string().required('From Time is required'),
  toTime: yup
    .string()
    .required('To Time is required')
    .test(
      'is-after-fromTime',
      'To Time must be after From Time',
      FormValidationUtil.toTimeAfterFromTime('fromTime'),
    )
    .test(
      'min-3-hours-diff',
      'Time difference must be greater than 3 hours',
      FormValidationUtil.timeDiffMoreThanEqualInHrs(3, 'fromTime'),
    )
    .test(
      'max-24-hours-diff',
      'Compoff hours cannot exceed 24 hours.',
      FormValidationUtil.timeDiffLessThanOrEqualInHrs(24, 'fromTime'),
    ),
  reason: yup.string().required('Reason is required'),
  file: yup
    .array()
    .min(1, 'Attachment is required')
    .test(
      'fileSize',
      `File size must be less than ${FileUtil.DEFAULT_ATTACHMENT_SIZE_MB}MB`,
      FormValidationUtil.validateMultipleFilesSize(
        FileUtil.DEFAULT_ATTACHMENT_SIZE_B,
      ),
    )
    .test(
      'fileFormat',
      FormValidationUtil.validateMultipleFilesFormatMessage(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
      FormValidationUtil.validateMultipleFilesFormat(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
    ),
  hrs: yup
    .number()
    .required('Hours are required')
    .typeError('Hours are required'),
  leaveDays: yup
    .number()
    .required('Leave days are required')
    .typeError('Leave days are required'),
});

export const populateFormValues = data => ({
  compOffCategory: data?.CompOffCategory || '',
  compOffDate: DateUtil.formatDateTimeToHtmlDate(data?.CompOffDate) || '',
  fromTime: data?.FromTime
    ? DateUtil.convertTimeToHTMLTimeRegex(data.FromTime)
    : '',
  toTime: data?.ToTime ? DateUtil.convertTimeToHTMLTimeRegex(data.ToTime) : '',
  attachmentPath: data?.AttachmentPath || '',
  reason: data?.Reason || '',
});
